<div class="bottom-sheet">
  <div>{{data.message}}</div>
  <button mat-button class="change" type="submit" (click)="accept()">Yes</button>
  <button mat-button type="button" color="warn" (click)="cancel()">No</button>
</div>